// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1v9pk","header":"ReportDetails_header__TNYIS","title":"ReportDetails_title__2Xy2V","left":"ReportDetails_left__1Hp89"};